import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';

export const AboutPageWrapper = styled(motion.div)`
  padding: 0 55rem;

  ${mediaTablet(`
    padding: 0 96rem;
  `)}
`;

export const PageTitleWrapper = styled(motion.div)`
  margin: 0 0 251rem;

  ${mediaTablet(`
    margin: 0 0 189rem;
  `)}
`;

export const SidesTextWrapper = styled(motion.section)`
  margin: 0 0 546rem;

  ${mediaTablet(`
    margin: 0 0 597rem;
  `)}
`;

export const Wrapper = styled.section`
  padding: 55rem 0 480rem;
  position: relative;

  ${mediaTablet(`
    padding: 55rem 271rem 150rem;
  `)}

  ${mediaDesktop(`
    padding: 188rem 271rem 480rem;
  `)}
`;

export const BottomBar = styled(motion.div)`
  padding: 110rem 55rem;

  ${mediaTablet(`
    display: flex;
    justify-content: center;
    padding: 110rem 55rem;
    margin: 0 auto;
  `)}

  ${mediaDesktop(`
    padding: 110rem 0;
  `)}
`;
